<template>

  <div class="pb50">
    <el-form ref="form" size="small" :model="form" label-width="200px">
      <div class="common-form">设置</div>
       <el-form-item label="是否开启每日分红">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="lh18 mt10 gray9">
          <p>开启后，可记录分红订单以及发放每日分红</p>
        </div>
      </el-form-item>
       <el-form-item label="单品奖金结算到余额">
        <el-radio-group v-model="form.resolve10_to_balance">
          <el-radio :label="10">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="lh18 mt10 gray9">
          <p>开启后，单品奖金结算到余额将结算到余额</p>
        </div>
      </el-form-item>
      <el-form-item label="单品奖金池分红条件 " prop="daily_resolve1" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入数字" type="number" min="0" v-model="form.daily_resolve1" class="max-w460">
          <template slot="append">份额</template>
        </el-input>
        <p>收益份额达到该值的用户可参与单品奖金池分红</p>
      </el-form-item>
      <el-form-item label="礼包奖金池分红条件 " prop="daily_resolve2" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入数字" type="number" min="0" v-model="form.daily_resolve2" class="max-w460">
          <template slot="append">份额</template>
        </el-input>
        <p>收益份额达到该值的用户可参与礼包奖金池分红</p>
      </el-form-item>
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>

    </el-form>
  </div>
</template>
<script>
  import BonusApi from '@/api/weightbonus.js';
  export default {
    data() {
      return {
        form: {
          is_open: 0,
          daily_resolve1:0,
          daily_resolve2:0,
          resolve10_to_balance:0,
        },
        loading: false,
      };
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {
      /*获取数据*/
      getData() {
        let self = this;
        let Params = {};
        BonusApi.getSetting(Params, true).then(res => {
          self.form = res.data.setting;
          if(res.data.setting.is_open){
             self.form.is_open = parseInt(res.data.setting.is_open);
          }
         
        }).catch(error => {

        });
      },

      /*保存*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            BonusApi.setSetting(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，保存成功',
                    type: 'success'
                  });
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });

          }
        });


      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/weightbonus/setting/index.vue